export default __webpack_public_path__ + "static/media/IconDesc_Snowman.256.652050cc.png";